import React from "react";
import { Trans } from "@coworker/locales";
import styles from "./profile-section.module.css";
import { FixaListViewItem } from "../../../../shared/wrappers/FixaListView/FixaListViewItem";
import { FixaSkeleton } from "../../../../shared/wrappers/FixaSkeleton/FixaSkeleton";

interface ProfileSectionListViewProps {
  id: string;
  titleTranslationKey: string;
  isNavigational: boolean;
  isTitleBold: boolean;
  description?: string;
  ssrIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  loading?: boolean;
}

export const ProfileSectionListViewItem: React.FC<
  ProfileSectionListViewProps
> = ({
  id,
  loading,
  isNavigational,
  titleTranslationKey,
  description,
  isTitleBold,
  ssrIcon,
}) => {
  if (loading) {
    return <FixaSkeleton width="100%" height="73px" />;
  }
  return (
    <>
      <FixaListViewItem
        className={styles["profile-list-item"] || ""}
        key={id}
        id={id}
        control={isNavigational ? "navigational" : "default"}
        inset
        controlIcon={isNavigational ? "chevronRight" : null}
        title={<Trans>{titleTranslationKey}</Trans>}
        description={description ?? ""}
        size="medium"
        emphasised={isTitleBold}
        leadingIcon={ssrIcon ? ssrIcon : () => []}
      />
    </>
  );
};
